function syncCardInert(card: HTMLElement): void {
  const expanded = card.classList.contains('is-expanded');
  const openBtn = card.querySelector<HTMLButtonElement>('[data-flip-card-open]');
  const front = card.querySelector<HTMLElement>('[data-flip-card-front]');
  const back = card.querySelector<HTMLElement>('[data-flip-card-back]');
  if (!openBtn || !front || !back) {
    return;
  }

  openBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  if (expanded) {
    front.setAttribute('inert', '');
    back.removeAttribute('inert');
  } else {
    back.setAttribute('inert', '');
    front.removeAttribute('inert');
  }
}

function hasInteractiveAncestor(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    Boolean(
      target.closest(
        'button, a, input, select, textarea, summary, [role="button"], [data-flip-card-ignore]'
      )
    )
  );
}

export default function flipCardGrid(root: HTMLElement): void {
  const list = root.querySelector<HTMLUListElement>('ul[role="list"]');
  const cards = [...root.querySelectorAll<HTMLElement>('[data-flip-card]')];
  const staticCards = [...root.querySelectorAll<HTMLElement>('li > article:not([data-flip-card])')];

  if (list && cards.length === 0 && staticCards.length === 0) {
    root.hidden = true;
    return;
  }

  for (const card of cards) {
    const openBtn = card.querySelector<HTMLButtonElement>('[data-flip-card-open]');
    const closeBtn = card.querySelector<HTMLButtonElement>('[data-flip-card-close]');
    const front = card.querySelector<HTMLElement>('[data-flip-card-front]');
    const back = card.querySelector<HTMLElement>('[data-flip-card-back]');
    if (!openBtn || !closeBtn) {
      continue;
    }

    if (card.dataset.flipCardInitial === 'true') {
      card.classList.add('is-expanded');
    }
    syncCardInert(card);

    const expand = (options?: { moveFocus?: boolean }): void => {
      card.classList.add('is-expanded');
      syncCardInert(card);
      if (options?.moveFocus) {
        closeBtn.focus();
      }
    };

    const collapse = (options?: { moveFocus?: boolean }): void => {
      card.classList.remove('is-expanded');
      syncCardInert(card);
      if (options?.moveFocus) {
        openBtn.focus();
      }
    };

    openBtn.addEventListener('click', event => {
      event.preventDefault();
      expand();
    });

    openBtn.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        expand({ moveFocus: true });
      }
    });

    front?.addEventListener('click', event => {
      if (hasInteractiveAncestor(event.target)) {
        return;
      }

      if (!card.classList.contains('is-expanded')) {
        expand();
      }
    });

    back?.addEventListener('click', event => {
      if (hasInteractiveAncestor(event.target)) {
        return;
      }

      if (card.classList.contains('is-expanded')) {
        collapse();
      }
    });

    closeBtn.addEventListener('click', event => {
      event.preventDefault();
      collapse();
    });

    closeBtn.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        collapse({ moveFocus: true });
      }
    });

    card.addEventListener('keydown', event => {
      if (event.key === 'Escape' && card.classList.contains('is-expanded')) {
        event.preventDefault();
        collapse({ moveFocus: true });
      }
    });
  }
}
